module.exports = function(c) {

	var numeric = function(field) {
		var rv = Number(field || 0);
		if (Number.isNaN(rv)) {
			rv = 0;
		}
		return rv;
	};

	var count = function(field, split_pattern) {
		if (field) {
			return field.split(split_pattern).length;
		} else {
			return 0;
		}
	};

	var bool = function(field, match) {
		if (field && field.toString().match(match)) {
			return true;
		} else {
			return false;
		}
	};

	var o = {
		cmc: numeric(c.cmc),
		power: numeric(c.power),
		toughness: numeric(c.toughness),
		abilities: count(c.text, /\n/),
		abilitiesWordCount: count(c.text, / /),

		isStarPower: bool(c.power, /\*/),
		isStarToughness: bool(c.toughness, /\*/),
		isXPower: bool(c.power, /X/),
		isXToughness: bool(c.toughness, /X/),

		isCommon: c.rarity == 'Common',
		isUncommon: c.rarity == 'Uncommon',
		isRare: c.rarity == 'Rare',
		isMythic: c.rarity == 'Mythic Rare',

		isCreature: bool(c.type, /Creature/),
		isInstant: bool(c.type, /Instant/),
		isSorcery: bool(c.type, /Sorcery/),
		isEnchantment: bool(c.type, /Enchantment/),
		isLand: bool(c.type, /Land/),
		isTribal: bool(c.type, /Tribal/),
		isAura: bool(c.type, /Aura/),

		// averagePrice: c.price_average,
		// highPrice: c.price_high,
		// lowPrice: c.price_low,
	};

	return o;
};
